<template>

  <select
    v-model="selectedItems"
    @change="$emit('update:modelValue', selectedItems)"
    :disabled="disabled"
    :class="{'select-multiple': multiple}"
    :multiple="multiple">

    <option v-if="placeholder" :disabled="multiple" value="">{{ placeholder }}</option>
    <option v-for="option in localOptions" :value="option.value">{{ option.text }}</option>
  </select>

</template>

<script>
export default {

  emits: ['update:modelValue'],

  props: {

    modelValue: {
      type: [String, Number, Array, Object],
      default: '',
    },

    placeholder: {
      type: String,
      default: null
    },

    options: {
      type: [Array, Object],
      default: () => {return []}
    },

    multiple: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },
  },

  data: function () {
    return {
      selectedItems: this.value,
    }
  },

  computed: {

    localOptions() {
      if (_.isArray(this.options)) return this.options;
      if (_.isObject(this.options)) {
        let items = [];
        Object.entries(this.options).map(o => items.push({'value': o[0], 'text': o[1]}));
        items.sort((a, b) => {
          const textA = a.text.toUpperCase();
          const textB = b.text.toUpperCase();
          if (textA < textB) return -1;
          if (textA > textB) return 1;
          return 0;
        });
        return items;
      }
    }

  }
}
</script>

<style scoped>
.select-multiple {
  height: 80px!important;
}
</style>
